export class ChiefComplaintQuestion {
  constructor(
    title,
    priority,
    otherChiefComplaintId,
    otherChiefComplaintText,
    chiefComplaintId,
    id,
  ) {
    this.title = title;
    this.otherChiefComplaintId = otherChiefComplaintId;
    this.priority = priority;
    this.otherChiefComplaintText = otherChiefComplaintText;
    this.chiefComplaintId = chiefComplaintId;
    this.id = id;
  }
}
import QuestionDTOMixin from '@/Mixins/BaseInformation/ChiefComplaint/dto/Question.dto';
export default {
  inject: ['load'],
  data() {
    return {
      allQuestionsList: [],
      allActiveQuestionsList: [],
      chiefComplaintQuestion: new ChiefComplaintQuestion('', null, null, null, -1),
    };
  },
  mixins: [QuestionDTOMixin],
  methods: {
    getAllQuestionsHandler: function (chiefComplaintId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllQuestions', Number(this.$route.params.id) || chiefComplaintId)
        .then(() => {
          if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
            const data = this.$store.state.chiefComplaintQuestionModule.allQuestions;
            this.allQuestionsList = this.transformedAllQuestionsList([...data]);
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllQuestionsHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllQuestionsHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getAllActiveQuestionHandler: function (chiefComplaintId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllActiveQuestions', Number(this.$route.params.id) || chiefComplaintId)
        .then(() => {
          if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
            const data = this.$store.state.chiefComplaintQuestionModule.allActiveQuestions;
            this.allActiveQuestionsList = [...data];
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllQuestionsHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllQuestionsHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQuestionHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageQuestionId: id,
      };
      this.$store.dispatch('getQuestion', params).then(() => {
        if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
          let data = this.$store.state.chiefComplaintQuestionModule.question;
          this.chiefComplaintQuestion = this.getQuestion(data);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getQuestionHandler(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getQuestionHandler(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    createQuestionHandler: function () {
      if (this.onModalValidation()) {
        if (!this.load.val) {
          this.load.val = true;
        }
        this.$store.dispatch('createQuestion', this.chiefComplaintQuestion).then(() => {
          if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
            // this.$refs.confirm.showConfirmDialog = false;
            this.showAddEditModal = false;
            this.disabelConfirm = false;
            this.snackText = 'سوال جدید با موفقیت ایجاد شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            if (this.load.val) {
              this.load.val = false;
            }
            this.clinicalTriage = new ChiefComplaintQuestion('', null, null, null, null);
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllQuestionsHandler();
          } else {
            this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.createQuestionHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.createQuestionHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      }
    },
    editQuestionHandler: function () {
      if (this.onModalValidation()) {
        this.chiefComplaintQuestion.id = this.selectedQuestion;
        if (!this.load.val) {
          this.load.val = true;
        }
        this.$store.dispatch('editQuestion', this.chiefComplaintQuestion).then(() => {
          if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
            this.showAddEditModal = false;
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllQuestionsHandler();
            this.snackText = 'سوال با موفقیت ویرایش شد.';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.clinicalTriage = new ChiefComplaintQuestion('', null, null, null, null, null);
          } else {
            // this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.editQuestionHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.editQuestionHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      }
    },
    deleteQuestionHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageQuestionId: id,
      };
      this.$store.dispatch('deleteQuestion', params).then(() => {
        if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
          this.disabelConfirm = false;
          // this.$refs.confirm.showConfirmDialog = false;
          this.snackText = 'سوال مورد نظر با موفقیت پاک شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllQuestionsHandler();
        } else {
          // this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteQuestionHandler();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteQuestionHandler();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deactiveQuestionHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageQuestionId: id,
      };
      this.$store.dispatch('deactiveQuestion', params).then(() => {
        if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
          this.disabelConfirm = false;
          // this.$refs.confirm.showConfirmDialog = false;
          this.snackText = 'سوال موردنظر غیرفعال شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllQuestionsHandler();
        } else {
          // this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteQuestionHandler();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteQuestionHandler();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    activeQuestionHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageQuestionId: id,
      };
      this.$store.dispatch('activeQuestion', params).then(() => {
        if (this.$store.state.chiefComplaintQuestionModule.successFlag) {
          this.disabelConfirm = false;
          // this.$refs.confirm.showConfirmDialog = false;
          this.snackText = 'سوال موردنظر فعال شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllQuestionsHandler();
        } else {
          // this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteQuestionHandler();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteQuestionHandler();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    showError: function () {
      this.snackText = this.$store.state.chiefComplaintQuestionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
